// ** Modules
import { useQuery } from '@apollo/client/react';
import { gql, type TypedDocumentNode } from '@apollo/client';

// ** Utils
import { RecursivePageLink } from './fragments';

// ** Types
import type { Query } from '@/types/graphql';

// ** Queries Schemas
export const getFooter: TypedDocumentNode<Pick<Query, 'footer'>> = gql`
	${RecursivePageLink}

	query Footer($locale: I18NLocaleCode) {
		footer(locale: $locale) {
			navColumns {
				title
				links {
					id
					label
					hrefExternal
					href {
						...RecursivePageLink
					}
				}
			}
			contact {
				heading
				phone
				email
				addressLines {
					id
					content
				}
			}
			socialLinks {
				id
				href
				key
			}
			legalLinks {
				id
				label
				hrefExternal
				href {
					...RecursivePageLink
				}
			}
			copyright {
				left
				right
			}
		}
	}
`;

//////////////////
// ** Query Functions

// Get Footer
export const useGetFooter = (locale: string, forceRefetch: boolean) => {
	const props = useQuery(getFooter, {
		variables: { locale },
		skip: !locale || locale === null,
		fetchPolicy: forceRefetch ? 'no-cache' : 'cache-first'
	});

	const data: Pick<Query, 'footer'> = props.data ?? { footer: null };

	return { ...props, data };
};
